import React from 'react'
import { MainAside } from '../../Components/Aside'

function SpatialIndex({ content, currentSectionKey }) {
  return (
    <section id={'spatialIndex'}>
      <div className={'quasi-iso-mask-top'} />
      <div className={'quasi-iso-mask-bottom'} />
      <MainAside content={content.main} />
      <SpatialIndexShowcase currentSectionKey={currentSectionKey} />
    </section>
  )
}

export function SpatialIndexShowcase({ currentSectionKey }) {
  const expandClass =
    currentSectionKey === 'spatialIndex' ? 'spatialIndex-expand' : ''
  const expandBubble_1 =
    currentSectionKey === 'spatialIndex' ? 'expand-1' : 'no-expand-1'

  return (
    <div id={'spatialIndexShowcase-wrapper'}>
      <img
        className={'spatialIndexBubble ' + expandBubble_1}
        src={'/publicAssets/newlab-poi.png'}
        alt={'bubble'}
      />

      <div id={'spatialIndexShowcase-ground'}>
        <div id={'spatialIndexShowcase-layer-1'} className={expandClass} />
        <div id={'spatialIndexShowcase-layer-2'} className={expandClass} />
        <div id={'spatialIndexShowcase-layer-3'} className={expandClass}>
          {/* <div id={'spatialIndexShowcase-layer-4'} className={expandClass}> */}
          <img
            id={'spatialIndexScreencap'}
            src={'/bigAssets/spatialIndex.png'}
            alt={'Spatial Index'}
          />
        </div>
      </div>
    </div>
  )
}

export default SpatialIndex



// WEBPACK FOOTER //
// ./src/Views/Home/SpatialIndex.js